/**
 * 经销商用户
 */

// 模块文件配置
const { VITE_APP_AFTER } = import.meta.env
const prefix = VITE_APP_AFTER
export default [
  // 经销商用户列表
  { name: 'businessUserList', url: `${prefix}/selectDealerUserPageList`, method: 'get' },
  // 添加经销商
  { name: 'insertDealerUserMerge', url: `${prefix}/insertDealerUserMerge`, method: 'post' },
  // 修改经销商
  { name: 'updateDealerUserMerge', url: `${prefix}/updateDealerUserMerge`, method: 'post' },
  // 更改经销商使用状态
  { name: 'updateBatchDealerUserStatus', url: `${prefix}/updateBatchDealerUserStatus`, method: 'post' },
  // 更改经销商黑名单状态
  { name: 'updateBatchDealerUserBlacklistStatus', url: `${prefix}/updateBatchDealerUserBlacklistStatus`, method: 'post' },
  // 重置密码
  { name: 'resetDealerUserPassword', url: `${prefix}/resetDealerUserPassword`, method: 'post' },
  // 解绑经销商
  { name: 'unbindDealerUserByDeviceId', url: `${prefix}/unbindDealerUserByDeviceId`, method: 'post' },
  // 删除经销商
  { name: 'deleteDealerUserMerge', url: `${prefix}/deleteDealerUserMerge`, method: 'post' },
  // 查询经销商详情
  { name: 'selectDealerUserMerge', url: `${prefix}/selectDealerUserMerge`, method: 'get' },
  // 获取单个经销商管辖的所有用户列表
  { name: 'selectOneDealerUserJurisdictionAllAppletUserList', url: `${prefix}/selectOneDealerUserJurisdictionAllAppletUserList`, method: 'get' },
  // 获取单个经销商绑定的所有设备列表
  { name: 'selectOneDealerUserBindingAllDeviceList', url: `${prefix}/selectOneDealerUserBindingAllDeviceList`, method: 'get' },
  
  /* ---记录 */
  // 使用
  { name: 'selectDealerAppletUserDeviceUseCountRecordPageList', url: `${prefix}/selectDealerAppletUserDeviceUseCountRecordPageList`, method: 'get' },
  // 连接
  { name: 'selectDealerAppletUserDeviceConnectionCountRecordPageList', url: `${prefix}/selectDealerAppletUserDeviceConnectionCountRecordPageList`, method: 'get' },

  /* --- 经销商平台 */
  // 查询经销商列表详细信息
  { name: 'selectDealerUserDetails', url: `${prefix}/selectDealerUserDetails`, method: 'get' },
  // 修改经销商用户密码
  { name: 'updateDealerUserPassword', url: `${prefix}/updateDealerUserPassword`, method: 'post' },
  
]
